/**
 *
 * Asynchronously loads the component for AuthorizationPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./AuthorizationPage"));
